<script lang="ts" setup>
  import { computed } from 'vue';
  import { useUnitFormatter, Unit } from '@othercommerce/domain';
  import { useTranslator } from '@othercommerce/foundation';

  interface PackagedEntity {
    stockUnit: Unit;
    packageUnit: Unit;
    packageQuantity: string;
  }

  interface Props {
    product: PackagedEntity;
  }

  const props = defineProps<Props>();
  const translator = useTranslator();
  const unitFormatter = useUnitFormatter();

  const message = computed(() => {
    let quantity = props.product.packageQuantity;
    let unit = props.product.packageUnit;
    let stock = props.product.stockUnit;

    if (unit === Unit.Piece && quantity === '1.0000') {
      return undefined;
    }

    return translator.trans('SHOP.COMMON.LABEL.PACKAGING_CONTAINS', {
      packaging: translator.choice(`UNIT.${unit}.LONG`, 1),
      unit: unitFormatter.accusative(stock, quantity),
    });
  });
</script>
<template>
  <div v-if="message" class="product-pack-quantity" v-html="message" />
</template>
<style lang="scss" scoped>
  .product-pack-quantity {
    font-size: 0.75rem;
    font-family: var(--font-family-sans);
    color: var(--color-default);
    font-weight: var(--font-weight-regular);
    padding: 0;
    margin: 0;

    .contains {
      display: block;
    }
  }
</style>
